import React, { useState }  from "react";

import homeIcon from "../imgs/home-nav.png"
import coin from "../imgs/coin.png"
import newsIcon from "../imgs/news.png"
import distance from "../imgs/distance.png"
import trailer from "../imgs/trailer icon.png"
import { body } from "ionicons/icons";
import {Link} from "react-router-dom";
import { PushNotificationsService } from "../api/PushNotificationsService";
import { userStore, UserState } from "../api/AuthService";
import { DriverProfile } from "../api/model/DriverProfile";

type Props = {
    onSearch: (target: boolean) => void
}

const Nav = (props: any) => {
    const currentPage = window.location.href.toLowerCase();

    return ( // DAMITRY: THE ID HAS TO GO ON EVERY SECTION FOR REACT JOURNEY CLICK CHECK PURPOSES (FirstSIgnIn.tsx)
        <div className="item-container" id="navi">
            <div className="nav-items">
                <Link to="/Home" style={{ textDecoration: "none"}} id={`${props.pageName}navHomeMain`} onClick={e => {PushNotificationsService.registerAfterAppLogin(userStore.getState().user!.id)}}>
                    <div id={`${props.pageName}navHomeMain`}>
                        <img src={homeIcon} alt="home" id={`${props.pageName}navHomeMain`}/>
                        <p style={{ color: currentPage.match('/home')? "#ED8254" : "#ffffff"}} id={`${props.pageName}navHomeMain`}>Home</p>
                    </div>
                </Link>
                <Link to="/Load" style={{ textDecoration: "none"}} id={`${props.pageName}navLoadMain`}>
                    <div id={`${props.pageName}navLoadMain`}>
                        <img src={trailer} alt="load" id={`${props.pageName}navLoadMain`}/>
                        <p style={{ color: currentPage.match('/load')? "#ED8254" : "#ffffff"}} id={`${props.pageName}navLoadMain`}>Load</p>
                    </div>
                </Link>
                <Link to="/Trip" style={{ textDecoration: "none"}} id={`${props.pageName}navTripMain`}>
                    <div id={`${props.pageName}navTripMain`}>
                        <img src={distance} alt="trip" id={`${props.pageName}navTripMain`}/>
                        <p style={{ color: currentPage.match('/trip') ? "#ED8254" : "#ffffff"}} id={`${props.pageName}navTripMain`}>Trip</p>
                    </div>
                </Link>
                <Link to="/Money" style={{ textDecoration: "none"}} id={`${props.pageName}navMoneyMain`}>
                    <div id={`${props.pageName}navMoneyMain`}>
                        <img src={coin} alt="pay" id={`${props.pageName}navMoneyMain`}/>
                        <p style={{ color: currentPage.match('/money')? "#ED8254" : "#ffffff"}} id={`${props.pageName}navMoneyMain`}>Pay</p>
                    </div>
                </Link>
                <Link to="/Docs" style={{ textDecoration: "none"}} id={`${props.pageName}navDocsMain`}>
                    <div id={`${props.pageName}navDocsMain`}>
                        <img src={newsIcon} alt="docs" id={`${props.pageName}navDocsMain`}/>
                        <p style={{ color: currentPage.match('/docs')? "#ED8254" : "#ffffff"}} id={`${props.pageName}navDocsMain`}>Docs</p>
                    </div>
                </Link>
            </div>

        </div>
    )
}

export default Nav
